<template>
  <el-dialog
    title="预览文件"
    :visible.sync="dialogVisible"
    custom-class="previewDialog"
    width="98%"
    top="2vh"
    @open="open"
    @opened="opened"
    @close="close"
    :append-to-body="true"
  >
    <!-- pdf  button -->
    <p class="tools" v-if="numPages > 10">
      <el-button v-if="!disabled" size="mini" type="primary" :disabled="btnLoading || currentPage === 1" @click="changePdfPage(0)">上一页</el-button>
      <!-- 详情页预览按钮 -->
      <span v-else :class="['jump-btn', currentPage === 1 ? 'hiddenClass' : '']" v-loading="btnLoading" @click="changePdfPage(0)">上一页</span>
      <el-select v-if="!disabled" size="mini" v-model="currentPage" style="width: 60px; margin-left: 10px;" @change="jumpPdfPage">
        <el-option v-for="item in numPages" :key="item" :value="item" :label="item"></el-option>
      </el-select>
      <span v-if="disabled"> {{currentPage}} </span> / {{numPages}}
      <el-button v-if="!disabled" size="mini" type="primary" :disabled="btnLoading || currentPage === numPages" @click="changePdfPage(1)">下一页</el-button>
      <!-- 详情页预览按钮 -->
      <span v-else :class="['jump-btn', currentPage === numPages ? 'hiddenClass' : '']" v-loading="btnLoading" @click="changePdfPage(1)">下一页</span>
    </p>
    <div
      v-if="dialogVisible"
      v-loading="loading"
      element-loading-text="文件加载中，请稍后..."
      :style="{position: 'relative', overflow: 'auto', height: dialogHeight + 'px'}"
    >
      <div v-show="type === 'pdf'">
        <!-- pdf超过10页分页展示 -->
        <div v-if="numPages > 10">
          <pdf
            :src="pdfUrl"
            :page="currentPage"
            @page-loaded="pageLoaded"
            @loaded="loadPdfHandler">
          </pdf>
        </div>
        <div v-else>
          <pdf v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>
        </div>
      </div>
      <!-- wprd -->
      <div v-show="type === 'file'">
        <iframe
          style="width: 100%; height: 100%"
          :src="src"
          frameborder="0"
          scrolling="no"
          id="bdIframe"
          name="bdIframe"
        >
        </iframe>
      </div>
      <div style="text-align: center; height:100%; z-index: 99999999;" v-show="type !== 'file' && type !== 'pdf'">
        <el-image
          :src="imgSrc"
          :preview-src-list="[imgSrc]"
        ></el-image>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="!disabled" type="primary" size="mini" @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pdf from 'vue-pdf';

export default {
  components: {
    pdf
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'file',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      src: '',
      pdfUrl: '',
      imgSrc: '', 
      numPages: 1,
      currentPage: 1,
      dialogVisible: false,
      loading: false,
      btnLoading: false,
      dialogHeight: 550
    };
  },
  methods: {
    open() {
      this.currentPage = 1;
      this.loading = true;
      // // 判断是否是私密文件
      const isPrivateFile = this.url.split(':');
      if(isPrivateFile.length === 1 && isPrivateFile[0] !== 'https') {
        // 私密文件，获取带有过期时间的完整路径
        this.$http.setting
          .getSignedUrl(encodeURIComponent(this.url))
          .then(result => {
            setTimeout(() => {
              this.previewFile(`${result.data}&r=${Date.now()}`);
            }, 500);
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      } else {
        // 未加密文件
        setTimeout(() => {
          this.previewFile(`${this.url}?r=${Date.now()}`);
        }, 500);
      }
    },
    previewFile(url) {
      const iframe = document.querySelector('#bdIframe');
      iframe.onload = () => {
        this.loading = false;
      };
      if (this.type === 'pdf') {
        this.pdfUrl = url;
        this.getNumPages();
      } else if (this.type === 'file') {
        // 预览office
        this.src = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url);
      }else {
        this.imgSrc = url
        this.loading = false;
      }
    },
    opened() {
      this.computedHeight();
    },
    close() {
      this.pdfUrl = '';
      this.src = '';
      this.numPages = 1;
      this.currentPage = 1;
      this.loading = false;
      this.dialogVisible = false;
    },
    // iframe宽高
    computedHeight() {
      const oIframe = document.getElementById('bdIframe');
      const deviceWidth = document.documentElement.clientWidth;
      const deviceHeight = document.documentElement.clientHeight;
      this.dialogHeight = deviceHeight*0.83;
      oIframe.style.width = Number(deviceWidth) + 'px';
      if (this.type === 'pdf') {
        oIframe.style.height = Number(deviceHeight) + 'px';
      } else {
        oIframe.style.height = Number(deviceHeight)*.91 + 'px';
      }
    },
    // 加载pdf多页
    getNumPages() {
      let pSrc = this.pdfUrl;
      this.pdfUrl = pdf.createLoadingTask(pSrc);
      this.pdfUrl.promise.then(pdf => {
        this.numPages = pdf.numPages; // 这里拿到当前pdf总页数
        this.loading = false;
      }).catch(err => {
        this.$message.error('pdf 加载失败', err);
        this.loading = false;
      });
    },
    // pdf加载完成
    loadPdfHandler () {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    // 页面加载
    pageLoaded(e) {
      this.currentPage = e;
      setTimeout(() => {
        this.btnLoading = false;
      }, 500);
    },
    // 改变PDF页码
    changePdfPage (val) {
      if(this.btnLoading) return;
      this.btnLoading = true;
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        return;
      }
      if (val === 1 && this.currentPage < this.numPages) {
        this.currentPage++;
        return;
      }
      this.btnLoading = false;
    },
    // PDF跳转
    jumpPdfPage(e) {
      this.currentPage = e;
    }
  },
};
</script>

<style lang="less" scoped>
#bdIframe {
  position: absolute;
  top: -90px;
  left: 0;
}
/deep/ .tools {
  position: absolute;
  left: 50%;
  top: 30px;
  transform: translateX(-50%);
  z-index: 10000;
  text-align: center;
  .el-input__inner {
    padding-left: 8px;
  }
}
/deep/ .jump-btn {
  width: 60px;
  height: 30px;
  padding: 5px 10px;
  background: #AB0033;
  font-size: 12px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  .el-loading-spinner .circular {
    width: 15px;
  }
}
.hiddenClass {
  background: rgb(237, 148, 142);
  cursor: not-allowed;
}
</style>

<style lang="less">
.previewDialog {
  margin: 0 auto;
  .el-dialog__body {
    padding: 5px 10px;
  }
}
</style>
